import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  certificateWs: null,
  userCertificate: {},
  progress: 0
};

// A slice
const certificateWsSlice = createSlice({
  name: 'certificateWs',
  initialState,
  reducers: {
    loadGeneratedCertificate: (state, action) => {
      state.userCertificate[action.payload.user_id] = action.payload;
      state.progress = eval(action.payload.progress) * 100;
    }
  }
});

// Actions generated from the slice
const { loadGeneratedCertificate } = certificateWsSlice.actions;

// export The reducer
const certificateWsReducer = certificateWsSlice.reducer;

export default certificateWsReducer;

// Actions

// Actions
export const handleGeneratedCertificate = (certificateData) => async (dispatch) => {
  dispatch(loadGeneratedCertificate(certificateData));
};
